module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-intems-center"
  }, [_vm._m(0), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "disabled": _vm.disabled,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.isCutoffActiveVal),
      callback: function($$v) {
        _vm.isCutoffActiveVal = $$v
      },
      expression: "isCutoffActiveVal"
    }
  })], 1)])]), _vm._v(" "), (_vm.isCutoffActiveVal == true) ? _c('div', [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mt-2 text-left fs-small dark"
  }, [_c('span', {
    staticClass: "hoverLink",
    on: {
      "click": function($event) {
        return _vm.selectAllAgent(true)
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "hoverLink",
    on: {
      "click": function($event) {
        return _vm.selectAllAgent(false)
      }
    }
  }, [_vm._v("None")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-0 px-2 py-1 bg-lightest border-light radius-normal"
  }, _vm._l((_vm.channelsTreated), function(channel) {
    return _c('div', {
      staticClass: "d-flex"
    }, [_c('checkbox', {
      staticClass: "mt-1",
      attrs: {
        "disabled": _vm.disabled
      },
      on: {
        "input": function($event) {
          return _vm.channelCheckboxChanged($event, channel)
        }
      },
      model: {
        value: (channel.selected),
        callback: function($$v) {
          _vm.$set(channel, "selected", $$v)
        },
        expression: "channel.selected"
      }
    }, [_vm._v("\n                            " + _vm._s(channel.name) + "\n                        ")]), _vm._v(" "), (channel.channelType == 50) ? _c('div', {
      staticClass: "ml-2"
    }, [_c('v-select', {
      attrs: {
        "disabled": _vm.disabled || (_vm.selectedChannels && !_vm.selectedChannels.some(function (i) { return i.channelType == 50; })),
        "options": _vm.agentsChannelOptions
      },
      on: {
        "input": function($event) {
          return _vm.agentsChannelChanged($event)
        }
      },
      model: {
        value: (_vm.agentsChannelSelectionOption),
        callback: function($$v) {
          _vm.agentsChannelSelectionOption = $$v
        },
        expression: "agentsChannelSelectionOption"
      }
    }), _vm._v(" "), (_vm.isCustoAgentSelection) ? _c('agent-white-list', {
      staticClass: "mt-2",
      attrs: {
        "disabled": _vm.disabled,
        "allowedIdArray": _vm.allowedList,
        "blockedList": _vm.blockedList,
        "startAllSelected": false
      },
      on: {
        "input": _vm.agentListChanged
      }
    }) : _vm._e()], 1) : _vm._e()], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cutOffTimeVal),
      expression: "cutOffTimeVal"
    }],
    attrs: {
      "disabled": _vm.disabled,
      "type": "number",
      "size": "3"
    },
    domProps: {
      "value": (_vm.cutOffTimeVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cutOffTimeVal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-2"
  }, [_vm._v("hour(s)")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('checkbox', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.softCutOffVal),
      callback: function($$v) {
        _vm.softCutOffVal = $$v
      },
      expression: "softCutOffVal"
    }
  }, [_vm._v("Soft cutoff")]), _vm._v(" "), _c('span', {
    staticClass: "dark fs-small"
  }, [_vm._v("Soft cutoff instead of closing will allow new reservations but these will require manual confirmation.")])], 1)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Cutoff")]), _vm._v(" "), _c('span', {
    staticClass: "dark fs-small"
  }, [_vm._v("Time for sales to close automatically")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Affected sales channels")]), _vm._v(" "), _c('span', {
    staticClass: "dark fs-small"
  }, [_vm._v("Select the sales channel you want to have cutoff, unselected sales channels will not have cutoff.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("Time before event starts")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b83d3716"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/cutoff/cutoffManager.vue
// module id = 1386
// module chunks = 0